import axios from 'axios'
export default {
  namespaced: true,
  state: {
    notificationAdminTriggeredGrid: [
      // {
      //     id: 123,
      //     title: 'Some title 1',
      //     body: 'Message 1',
      //     schedule: {},
      //     recipients: [1, 234, 56],
      //     created_at: '2021-11-29 14:00:00',
      //     updated_at: '2021-11-30 15:00:00',
      // },
      // {
      //     id: 456,
      //     title: 'Some title 2',
      //     body: 'Message 2',
      //     schedule: {},
      //     recipients: [3, 92],
      //     created_at: '2021-11-29 14:00:00',
      //     updated_at: '2021-11-30 15:00:00',
      // },
    ],
    notificationAdminTriggeredTypes: [],
    notificationAdminTriggeredShow: null,
    pageData: null,
    notificationAdminTriggeredTriggersList: [],
  },
  mutations: {
    setNotificationAdminTriggeredGrid(state, payload) {
      state.notificationAdminTriggeredGrid = payload
    },
    setNotificationAdminTriggeredTypes(state, payload) {
      state.notificationAdminTriggeredTypes = payload
    },
    setNotificationAdminTriggeredShow(state, payload) {
      state.notificationAdminTriggeredShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
    setNotificationAdminTriggeredTriggersList(state, payload) {
      state.notificationAdminTriggeredTriggersList = payload
    },
  },
  getters: {
    notificationAdminTriggeredGrid: (state) => state.notificationAdminTriggeredGrid,
    notificationAdminTriggeredShow: (state) => state.notificationAdminTriggeredShow,
    notificationAdminTriggeredTriggersList: (state) => {
      let array = []
      for (const [key, value] of Object.entries(state.notificationAdminTriggeredTriggersList)) {
        array.push({ value: key, text: value })
      }
      return array
    },
    pageData: (state) => state.pageData,
  },
  actions: {
    onNotificationAdminTriggeredGrid({ commit, rootState }, { limit, page, sort, search, filter }) {
      let url =
        rootState.apiDomain +
        '/api/admin/notification/triggered-notification?limit=' +
        limit +
        '&page=' +
        page
      if (filter) {
        url = url + '&filter[]=trigger:' + filter
      }
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=created_at:desc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setNotificationAdminTriggeredGrid', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationAdminTriggeredTypes({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/notification/schedule/types?notification_type=triggered',
          method: 'GET',
        })
          .then((resp) => {
            commit('setNotificationAdminTriggeredTypes', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationAdminTriggeredShow({ commit, rootState }, { id }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/notification/triggered-notification/' + id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setNotificationAdminTriggeredShow', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationAdminTriggeredCreate({ rootState }, { data }) {
      return new Promise((resolve, reject) => {
        console.log(data)
        axios({
          url: rootState.apiDomain + '/api/admin/notification/triggered-notification/',
          data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationAdminTriggeredUpdate({ rootState }, { id, data }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/notification/triggered-notification/' + id,
          data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationAdminTriggeredDelete({ rootState }, { id }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/notification/triggered-notification/' + id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationAdminTriggeredTriggersList({ commit, rootState }) {
      let url = rootState.apiDomain + '/api/admin/notification/triggered-notification/triggers'
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setNotificationAdminTriggeredTriggersList', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onNotificationAdminTriggeredProcessActivation({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain + '/api/admin/notification/triggered-notification/process-triggers',
          method: 'GET',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
